import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnModel } from 'neo-table-lib';
import { LocalDataSource } from 'ng2-smart-table';
import { Row } from 'ng2-smart-table/lib/data-set/row';
import { ToastrService } from 'ngx-toastr';
import { AbstractBaseListComponent } from 'src/app/core/component/abstract-base-list-component';
import { ResponseCode } from 'src/app/core/constant/response-code';
import { TableKeyEnum } from 'src/app/core/enum/table-key.enum';
import { FileUtilService } from 'src/app/core/service/FileUtil/file-util.service';
import { IBaseService } from 'src/app/core/service/ibase-service';
import { ModuleParamGlobConfigService } from 'src/app/core/service/moduleFieldConfig/module-param-glob-config.service';
import { getColumnExists, getColumnObject } from 'src/app/core/utils/helpers';
import { CommonSelectListService } from 'src/app/shared/service/common-select-list.service';
import { UserModal } from '../../user/modal/user-modal';
import { CategoryTypeModel } from '../model/category-type-model';
import { CategoryTypeModuleParamModel } from '../model/category-type-module-param-model';
import { CategoryTypeService } from '../service/category-type.service';

@Component({
  selector: 'app-category-typle-list',
  templateUrl: './category-typle-list.component.html',
  styleUrls: ['./category-typle-list.component.css'],
})
export class CategoryTypleListComponent extends AbstractBaseListComponent<CategoryTypeModel> implements OnInit {
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'categorytype';
  public dataList: Array<CategoryTypeModel>;
  addUpdateUrl: string = 'module/categorytype/categoryTypeAddUpdate';
  private userList: UserModal[];
  @ViewChild('actionCol') actionCol: TemplateRef<any>;
  moduleParams: CategoryTypeModuleParamModel = new CategoryTypeModuleParamModel(this.moduleParamConfigGlob);
  CategoryTypeTitle = this.moduleParams.paramData.title.label;
  dataSource = new MatTableDataSource([]);
  filteredData: any;
  allDataList: CategoryTypeModel[];
  allColumns: any[] = [
    {
      colKey: 'index',
      default: 'Sr No.',
      rowKey: 'id',
      isNumber: true,
      width: '8%'
    },

    {
      colKey: 'label',
      default: this.moduleParams.paramData.name.label,
      rowKey: 'label',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '10%'
    },
    {
      colKey: 'key',
      default: this.moduleParams.paramData.category_type.label,
      rowKey: 'key',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '14%'
    },
    {
      colKey: 'partyString',
      default: this.moduleParams.paramData.party_type.label,
      rowKey: 'partyString',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '20%'
    },
    {
      colKey: 'description',
      default: this.moduleParams.paramData.description.label,
      rowKey: 'description',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'actionCol',
      default: 'Action',
      rowKey: 'id',
      isNumber: false,
      isStickyEnd: true,
      width:'8%'
    },
  ];
  allFinalColumns: ColumnModel[] = [];
  tableKeyEnum = TableKeyEnum.CATEGORY_TYPLE;
  displayedColumns: string[];
  defaultSortCol = 'dateString';
  defaultSortDirection = 'asc';
  constructor(
    public service: CategoryTypeService,
    public fileUtil: FileUtilService,
    public listService: CommonSelectListService,
    private route: ActivatedRoute,
    private moduleParamConfigGlob: ModuleParamGlobConfigService,
    private router: Router,
    public toastrService: ToastrService
  ) {
    super(toastrService, router);
  }
  ngOnInit() {
    this.getUserList();
    this.init();
    this.setTableColumns();
  }
  setTableColumns() {
    // Input Table Columns
    this.allColumns.map((column, columnIndex) => {
      // column.isFilterAllow = true;
      column.enableEdit = true;
      column.enableDelete = true;
      let pushcol = false;
      column.isFilterAllow = false;
      column.enableSort = false;
      if (column.colKey == 'actionCol') {
        pushcol = true;
        column.enableEdit = false;
        column.enableDelete = false;
        column.customControls = [this.actionCol];
        column.isExpandable = false;
      } else {
        pushcol = true;
      }

      const pushcolVal = getColumnObject(column);
      if (pushcol && !getColumnExists(this.allFinalColumns, column.colKey)) {
        this.allFinalColumns.splice(columnIndex, 0, pushcolVal);
      }
    });
    this.displayedColumns = this.allFinalColumns.map((column) => column.colKey);
  }
  setDataSource(data) {
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    this.dataSource.connect().subscribe((data) => {
      this.filteredData = data;
    });
    if (this.service.pagination) setTimeout(() => this.assignValue(), 0);
  }

  assignValue() {
    this.dataSource.paginator.pageIndex = this.service.pagination.pageIndex;
    this.dataSource.paginator.pageSize = this.service.pagination.perPage;
  }

  getService(): IBaseService<CategoryTypeModel> {
    return this.service;
  }

  setList(list: Array<CategoryTypeModel>) {
    this.dataList = list;
    this.valuePreparation();
    this.setDataSource(this.dataList);
  }

  public getTableColumn(): any {
    let columnList = {
      name: {
        title: this.moduleParams.paramData.name.label,
        filter: false,
      },
      party_type: {
        title: this.moduleParams.paramData.party_type.label,
        filter: false,
      },
      description: {
        title: this.moduleParams.paramData.description.label,
        filter: false,
      },
    };

    return columnList;
  }

  public onDeleteClick(data: CategoryTypeModel) {
    if (confirm('Are you sure want to delete this record.')) {
      this.delete(data);
    }
  }

  public onEditClick(modal: CategoryTypeModel) {
    this.router.navigate([this.addUpdateUrl, modal.id]);
  }

  onSmartTableEditClick(eventData: Row) {
    this.onEditClick(eventData.getData());
  }

  onSmartTableDeleteClick(eventData: Row) {
    this.onDeleteClick(eventData.getData());
  }
  onNeoTableEditClick(event) {
    let index = event.rowIndex;
    this.onEditClick(this.filteredData[index]);
  }

  onNeoTableDeleteClick(event) {
    let index = event.rowIndex;
    this.onDeleteClick(this.filteredData[index]);
  }
  onHeaderRefresh($event: void) {
    this.getList(this.paginatioData, this.orderingData);
  }

  async generatePdf() {
    let setting = await this.fileUtil.getCloumnAndHeader(this.getTableColumn());
    this.fileUtil.convertIntoPdf(setting, this.dataList, 'categoryType', this.getTableColumn(), 'categoryType List');
    this.refreshLocalData();
  }

  async generateCSV() {
    let setting = await this.fileUtil.getCsvObject(this.getTableColumn());
    this.fileUtil.exportCSVFile(setting, this.dataList, 'categoryType', this.getTableColumn());
    this.refreshLocalData();
  }
  setToService() {
    let Obj = {
      pageIndex: this.dataSource.paginator.pageIndex,
      perPage: (this.dataSource.paginator.pageSize = 10),
    };

    this.service.pagination = Obj;
  }

  valuePreparation() {
    this.setToService();
    if (this.dataList && this.dataList.length !== 0) {
      this.dataList.forEach((list) => {
        list.partyString = list.partyType ? list.partyType.label : '';
      });
      this.source = new LocalDataSource(this.dataList);
    }
  }

  getUserList() {
    this.listService.getStaffList().subscribe((response) => {
      if (response.responseCode === ResponseCode.OK) {
        this.userList = new Array<UserModal>();
        this.userList = response.dataList;
        this.valuePreparation();
      } else {
        this.toastrService.error(response.responseMessage);
      }
    });
  }
}
